<template>
  <div v-if="showSidePanel" class="side-panel bg-white pa-8"
          style="z-index: 999">
    <v-icon style="float:right" @click.stop="close()">mdi-close</v-icon>
    <div class="side-panel__header justify-space-between">
      <h6 style="color: var(--gray-color_3);">{{element.name}}</h6>
     
    </div>
    <v-col class="d-flex flex-row">
      <div class="evaluation-info-number">
        <div class="average">⌀</div>
        <span class=element-info-text :style="'color: '+ getColor(element.averageScore)">{{element.averageScore}}</span>
      </div>
      <v-divider vertical style="margin:5px;"></v-divider>
      <div class="evaluation-info-text">
        <div>
          <v-icon :style="'font-size:2rem; color:'+getColor(element.averageScore)">{{getIcon(element.averageScore)}}</v-icon>
          <v-card-subtitle class="evaluation-info-title">{{getAverageAnswer(element.averageScore)}}</v-card-subtitle>
        </div>
        
        <!-- <span class=element-info-text>{{getAverageAnswer(element.averageScore)}}</span> -->
      </div>
    </v-col>
    <v-divider class="mb-0"></v-divider>
      <div id="surveyVizPanel" />
       <!--  <template>
          <v-data-table
              flat
              :headers="questionHeaders"
              hide-default-header
              :items="questionEvaluations"
              single-expand
              :expanded.sync="expanded"
              item-key="question.questionText"
              show-expand
              style="width: 100%; height:100%"
          >
            <template v-slot:item.averageScore="{item}">
              <td class="average-rate"
                  :style="'color: '+ getColor(item.averageScore)">{{item.averageScore}}</td>
            </template>
            <template v-slot:expanded-item="{ headers, item, index }" class="ma-0">
              <td :colspan="headers.length" class="question-list px-8">
                <v-col class="question-list__chart">
                  <ProcessElementQuestionBarChart :data="item"/>
                </v-col>
              </td>
            </template>
          </v-data-table>
        </template> -->
    </div>
</template>

<script>
import BarChart from "@/pages/PxQuestionSurvey/PXSurveyPage/Evaluation/Charts/BarChart.vue";
import ProcessElementQuestionBarChart from "./ProcessElementQuestionBarChart.vue";
import surveyEvaluationService from "@/components/surveyEvaluationService.js"
import "survey-analytics/survey.analytics.min.css";
import { Model } from "survey-core";
import { VisualizationPanel } from "survey-analytics";

const vizPanelOptions = {
  allowHideQuestions: false,
  allowDynamicLayout: false,
  haveCommercialLicense: true
};
export default {
  name: "PxElementQuestionEvaluationPanel",
  components: {
    BarChart,
    ProcessElementQuestionBarChart
},
  data() {
    return {
      showSidePanel: false,
      questionEvaluations: {},
      expanded: [],
      matrixValues: {
          1: "Sehr gut",
          2: "Gut",
          3: "Befriedigend",
          4: "Ausreichend",
          5: "Mangelhaft",
          6: "Ungenügend"
      },
      element: null,
      survey: null,
      answers: [],
      questionHeaders: [
      {
        text: 'Frage',
        align: 'start',
        sortable: true,
        value: 'question.text',
        width: '72%',
      },
      { text: 'Durchschnittliche Antwort', value: 'averageScore' },
      
      ],
      vizPanel: null
    }
  },
  mounted(){
  },
  updated(){
    const survey = new Model(this.survey);
    this.vizPanel = null;
    this.vizPanel = new VisualizationPanel(
      survey.getAllQuestions(),
      this.answers,
      vizPanelOptions
    );
    this.vizPanel.showHeader = false;
    this.vizPanel.render(document.getElementById("surveyVizPanel"));

    
  },
  methods: {
    open(elementEval, element, currentSurvey) {
      this.showSidePanel = false;
      this.questionEvaluations = [];
      this.element = null;
      this.survey = null;
      this.answers = [];
      surveyEvaluationService.retrieveAnswersForCustomSurvey(currentSurvey.id).then(res => {
        this.survey = JSON.parse(currentSurvey.schema);
        this.survey.pages = this.survey.pages.filter(elem => elem.name == element.id);
        res.data.forEach(elem => this.answers.push(JSON.parse(elem.answers)))
        this.survey.locale = "de";
        this.survey.pages[0].questions.forEach(elem => {
          if(elem.type == "matrix"){
            elem.title = elem.rows[0].text;
          }
          if(elem.inverted){
            elem.title += " (invertiert)"
          }
        })
        this.element = {
          elementId: element.id,
          name: element.name,
          averageScore: elementEval.overallScore
        };
        let evalData = [];
        elementEval.scores.forEach(score => {
          evalData.push({
              scores: score.scores,
              question: score.question,
              averageScore: score.answerScore
            })
        });
        this.questionEvaluations = evalData;
        this.showSidePanel = true;
        
        })
      
    },
    close() {
      this.questionEvaluations = [];
      this.element = null;
      this.survey = null;
      this.answers = [];
      this.showSidePanel = false;
    },
    getTrafficGreen(score) {
      if(score <= 2) return 'var(--green-color)';
      return '#D5D5D5';
    },
    getTrafficYellow(score) {
      if(score > 2 && score <= 4) return 'var(--yellow-color)';
      return '#D5D5D5';
    },
    getTrafficRed(score) {
      if(score >= 5) return 'var(--red-color)';
      return '#D5D5D5';
    },
    getScore(scoreVal){
      let score = 0;
      let evals = this.questionEvaluation.evalData.map(e => e.scores);
      if(this.questionEvaluation.inverted) scoreVal = 7-scoreVal;
      evals.forEach(elem => score += elem[scoreVal]);
      return score;
    },
    calcPercentageScore(scoreVal){
      let score = 0;
      let scoreCount = 0;
      let evals = this.questionEvaluation.evalData.map(e => e.scores);
      if(this.questionEvaluation.inverted) scoreVal = 7-scoreVal;
      evals.forEach(elem => {
        score += elem[scoreVal];
        scoreCount += Object.values(elem).reduce((a, b) => a + b)
      });
      return (100*(score/scoreCount)).toFixed(2);
    },
    getAverageRate(scores, inverted) {
      let sum = 0;
      let voter = 0;
      for (let score in scores) {
        sum += score * scores[score];
        voter += scores[score];
      }
      let rate = sum/voter;
      if(inverted) return Math.floor(7-rate);
      return Math.floor(rate);
    },
    getAverageAnswer(score) {
      if(score < 1.5){
        return this.matrixValues[1]
      }else  if(score < 2.5){
        return this.matrixValues[2]
      }else  if(score < 3.5){
        return this.matrixValues[3]
      }else if(score < 4.5){
        return this.matrixValues[4]
      }else if(score < 5.5){
        return this.matrixValues[5]
      }else{
        return this.matrixValues[6]
      }      
    },
    getColor(data){
        if(data <=2.5) return "var(--green-color)";
        if(data <=4.5) return "var(--yellow-color)";
        return "var(--red-color)";
    },
    getIcon(data){
      if(data <=2.5) return "mdi-emoticon-happy-outline";
      if(data <=4.5) return "mdi-emoticon-neutral-outline";
      return "mdi-emoticon-sad-outline";
    }
  },
}
</script>

<style scoped>
.average{
  position:absolute;
  color: gray;
}
.side-panel {
  position: fixed;
  width: 34vw;
  height: calc(100% - 50px);
  right: 0;
  top: 52px;
  bottom: 0;
  box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.12);
  overflow: auto;
}
.side-panel__infos__date {
  font-size: 10px;
}

:deep .evaluation-info {
  padding: 12px 8px;
  min-width: 166px;
  margin-left: 10px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.04));
}
:deep .evaluation-info-number {
  padding: 0px;
  min-width: 30px;
  margin-left: 10px;
  height: 50px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.04));
}
:deep .evaluation-info-text {
  padding: 0px;
  margin-left: 10px;
  height: 50px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.04));
}
:deep .evaluation-info-title {
  font-size: 12px;
  color: var(--gray-color_3);
  font-weight: 400;
  margin-left: 10px;
  margin: 0;
  padding: 0;
  text-transform: uppercase;
}
:deep .element-info-text {
  font-size: 2rem;
  color: var(--motiverse-secondary);
  font-weight: 600;
  margin: 0;
  padding: 0;
  float: right;
}
@media screen and (max-width: 1440px) {
  body {
    background-color: lightblue;
  }
  .trend-test {
    padding: 0;
  }
  .trend-test div {
    padding: 2px 4px !important;
  }
  .trend-left .v-chip {
    height: 28px;
    padding: 0 6px;
  }
  .trend-left .v-chip .v-icon {
    font-size: 14px;
  }
  .trend-left span {
    font-size: 1.3vmin !important;
  }
  .card-detail {
    font-size: 1.6vmin;
  }
}
:deep .sa-question{
  padding: 0px !important;
}
</style>